import React from "react";
import StarRatings from "react-star-ratings";

const StarRating = ({
  rating,
  starRatedColor = "#C4D26E",
  starEmptyColor = "#D9D9D9",
  numberOfStars = 5,
  starDimension = "20px",
  starSpacing = "2px",
}) => {
  return (
    <StarRatings
      rating={rating}
      starRatedColor={starRatedColor}
      starEmptyColor={starEmptyColor}
      numberOfStars={numberOfStars}
      name="rating"
      starDimension={starDimension}
      starSpacing={starSpacing}
    />
  );
};

export default StarRating;
